import type { ReturnMethodInfo } from 'shipping-and-returns/types/ReturnsInfoContext.types'

export const hasReturnMethod = (
	returnMethods: ReturnMethodInfo[],
	types: string | string[]
) =>
	Array.isArray(types)
		? returnMethods?.some((method) => types.includes(method.id))
		: returnMethods?.map((method) => method.id).includes(types)
